import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=6e74d779&"
import script from "./Resumen.vue?vue&type=script&lang=js&"
export * from "./Resumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Resumen.vue"
export default component.exports